/**
 * Single source of truth for review ratings.
 *
 * Verified 2026-10-10 on the live Google Business panel and Maps result
 *   (.audit/maintenance/runs/2026-10-10T130010Z/google-business.json; 2026-09-07 was 156):
 *   Google: 5.0★ from 175 reviews.
 *   (Was 117 on 2026-06-20 — ~15 new reviews a month.)
 *
 * Do NOT publish unverifiable aggregate review counts. FTC + Google review
 * policy require review counts/ratings to be truthful. Only the Google figures
 * below are independently verified; other platforms are linked to their own
 * (real) review pages WITHOUT asserting a count or rating we cannot verify.
 * If you obtain real, current per-platform counts, update them here with a date.
 */
export const REVIEWS = {
  google:      { rating: 5.0, count: 175 },
  tripadvisor: { rating: null, count: null },
  yelp:        { rating: null, count: null },
  overall:     5.0,
  total:       175,
  // One-click Google "write a review" short link (from the live profile).
  reviewLink:  'https://g.page/r/CQVUNfAn4M_7EBM/review',
};

/** Rating-led trust phrase — verified Google figure, no unverifiable aggregate. */
export const TOTAL_REVIEWS_TEXT = '5.0★ on Google';

/** "5.0" */
export const OVERALL_RATING_TEXT = REVIEWS.overall.toFixed(1);
